export default __webpack_public_path__ + "static/EDGI-logo-0d314dbe13618ac6059d5567945ee96a.webp";